import { BiChevronDown } from 'react-icons/bi';

import Accordion, { AccordionButton, AccordionPanel } from '@/components/@base/accordion';
import Container from '@/components/@base/container';
import { Heading, Text } from '@/components/@base/typography';
import { HEADING_TYPE } from '@/components/@base/typography/heading/type';
import XImage from '@/components/@base/x-image';
import Props from '@/components/shared/components/zhaket-custom-accordion/type';

import { DATA_CY_FAQ_ACCORDION_BUTTON, DATA_CY_FAQ_ACCORDION_PANEL } from '@/constant/cypress';
import imagesList from '@/constant/images-list';

export default function ZhaketCustomAccordion({
  buttonText,
  buttonIcon,
  panelContent,
}: Props) {
  return (
    <Accordion>
      <AccordionButton
        data-cy={DATA_CY_FAQ_ACCORDION_BUTTON}
        className='flex w-full items-center justify-between gap-2 rounded-lg bg-[#FFFFFF] p-3 shadow-[0px_5px_15px_0px_#494B540F] group-last:mb-0! ui-open:rounded-b-none ui-open:border-b-[1px] ui-open:border-b-[#EFEFEFD9] ui-not-open:mb-2 md:p-5 md:ui-not-open:mb-4'
      >
        <Container center className='max-w-[85%] gap-2.5'>
          {buttonIcon}
          <Heading
            className='truncate text-right text-sm text-[#575757] md:text-base'
            type={HEADING_TYPE.H3}
          >
            {buttonText}
          </Heading>
        </Container>
        <Container className='w-8'>
          <BiChevronDown className='h-5 w-8 text-silver ui-open:rotate-180 ui-open:transform ui-open:fill-[#FF7B01]' />
        </Container>
      </AccordionButton>
      <AccordionPanel
        data-cy={DATA_CY_FAQ_ACCORDION_PANEL}
        className='mb-2 rounded-b-lg bg-[#FFFFFF] p-3 text-sm text-gray-500 shadow-[0px_5px_15px_0px_#494B540F] md:mb-4 md:p-5'
      >
        {panelContent}
      </AccordionPanel>
    </Accordion>
  );
}
